import React from 'react';

import styles from './pressMediaStyles';

import Link from 'buyside/components/presentation/Link/link';
import Expandable from 'buyside/components/presentation/Expandable/expandable';

import { formatDate } from 'buyside/util/dateHelper';
import { defaultPressImageUrl } from 'buyside/util/urlHelper';

const PressMedia = ({ fundProfile: { presses }, createAuditRecord }) => {
  return (
    <Expandable maxItems={4}>
      {presses.map((press, idx) => (
        <div key={idx} className={styles.press}>
          <div className={styles.pressPreviewImageWrap}>
            <object
              className={styles.pressPreviewImage}
              data={press.previewImageUrl || defaultPressImageUrl()}
              type="image/png"
            >
              <img className={styles.pressPreviewImage} src={defaultPressImageUrl()} />
            </object>
          </div>
          <div className={styles.pressInfo}>
            <Link
              className={styles.pressLink}
              to={press.url || press.fileUrl}
              onMouseDown={() => createAuditRecord(press.id, 'EmployerProfilePress', 'click')}
              target="_blank"
            >
              {press.title}
            </Link>
            {press.publishDate && (
              <strong className={styles.pressInfoItem}>{formatDate(press.publishDate)}</strong>
            )}
            <div className={styles.pressInfoItem}>{press.description}</div>
          </div>
        </div>
      ))}
    </Expandable>
  );
};

export default PressMedia;
